import PropTypes from 'prop-types';
import { createContext } from 'react';

import useFetchData from 'src/hooks/useFetchData';
import LoadingScreen from 'src/components/LoadingScreen';

const TranslationsContext = createContext();

export const TranslationsProvider = ({ children }) => {
  const { result, loading } = useFetchData({
    path: '/translations',
    auth: true
  });

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <TranslationsContext.Provider value={{ ...result.data }}>
      {children}
    </TranslationsContext.Provider>
  );
};

TranslationsProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export default TranslationsContext;
